import { NextSeo } from 'next-seo';
import React, { useEffect, useRef, useState } from 'react';
import { useIntersection } from 'react-use';
import { updatedCategoryMapping } from '../../../src/Constants/ArticleCategoryMapping';
import {
  articleIdCanonicalMapping,
  getArticleData,
  getCustomRelatedUrls,
} from '../../../src/Utils/ArticleUtils';
import {
  getCartItems,
  getDeviceType,
  getScreenName,
  showNewCartFlow,
} from '../../../src/Utils/helper';
import { goToCartHandler } from '../../../src/Utils/productAction';
import {
  fireServedSectionEvent,
  fireViewedScreenEvent,
} from '../../../src/Utils/useFirebase';
import { getPublicUrl } from '../../../src/appconfig';
import ArticleProductCard from '../../../src/components/ArticlePage/ArticalProductCard/ArticleProductCard';
import ArticleDetail from '../../../src/components/ArticlePage/ArticleDetail/ArticleDetail';
import ArticleHead from '../../../src/components/ArticlePage/ArticleHead';
import ArticleImage from '../../../src/components/ArticlePage/ArticleImage';
import { ArticleGridSection } from '../../../src/components/ArticlePage/ArticleImage/styled';
import Content from '../../../src/components/ArticlePage/Content';
import DownloadAppBanner from '../../../src/components/ArticlePage/DownloadAppBanner/DownloadAppBanner';
import ExpertSection from '../../../src/components/ArticlePage/ExpertSection/ExpertSection';
import InfographicImage from '../../../src/components/ArticlePage/InfographicImage';
import InthisArticleSection from '../../../src/components/ArticlePage/InthisArticle/InthisArticleSection';
import IsthisHelpfulSection from '../../../src/components/ArticlePage/IsthisHelpful/IsthisHelpfulSection';
import ProductShowcase from '../../../src/components/ArticlePage/ProductShowcase/ProductShowcase';
import RelatedArticlesNew from '../../../src/components/ArticlePage/RelatedArticlesNew/RelatedArticlesNew';
import { ProductsMayLikeSection } from '../../../src/components/ArticlePage/RelatedArticlesNew/styled';
import RelatedQuestionNew from '../../../src/components/ArticlePage/RelatedQuestionNew';
import RelatedArticleTopics from '../../../src/components/ArticlePage/RelatedTopics/RelatedArticleTopics';
import { HomeWrapper } from '../../../src/components/HomePage/HomeBanner/styled';
import NewFooter from '../../../src/components/HomePage/NewFooter';
import NewHeader from '../../../src/components/HomePage/NewHeader';
import Loader from '../../../src/components/Loader';
import Card from '../../../src/components/Parenting/ArticlesAndVideos/Card';
import {
  FixedWithHeightDiv,
  SimilarVideoSection,
} from '../../../src/components/Parenting/ArticlesAndVideos/styled';
import RecentlyAddedArticlesCover from '../../../src/components/Parenting/RecentAddedArticles/RecentlyAddedArticlesCover';
import { SnackBar } from '../../../src/components/Product/PdpHeader/styled';
import {
  motherNudge,
  pregnancyNudge,
  ttcNudge,
} from '../../../src/components/QnaPage/InstallAppSection/constant';
import Breadcrumbs from '../../../src/components/StoreCategoryPage/Breadcrumbs';
import { BannerTitle } from '../../../src/components/StoreHomePage/BannersGrid/styled';
import GlobalStyle from '../../../src/styles/globalStylesV2';
import AssessmentStrip from '../../../src/components/QnaPage/AssessmentStrip';
import {
  getUsDataById,
  isUserFromIndia,
} from '../../../src/components/ArticlePage/Content/constant';
import AdsBanner from '../../../src/components/ArticlePage/AdsBanner';
import ScrollWrapper from '../../../src/components/ScrollWrapper/ScrollWrapper';
import { getWebUserType } from '../../../src/Utils/getWebUserType';
import { fireEvent } from '../../../src/Utils/fireEvent';

export async function getStaticPaths() {
  // if (getApiEndpoint() == "https://dev-api.myloapp.in/") {
  //     return {
  //         paths: [
  //             {
  //                 params: { articleId: "footnote-test-title-146335" },
  //                 locale: "hi",
  //             },
  //         ],
  //         fallback: "blocking",
  //     };
  // }
  return {
    paths: [{ params: { articleId: 'dalia-in-pregnancy-88977' } }],
    fallback: 'blocking',
  };
}

export async function getStaticProps(context) {
  return getArticleData(context, 'server');
}

export default function ArticlePageComponent(props) {
  const [articlePagePropsData, setArticlePagePropsData] = useState(props);
  const {
    articleDetail,
    articleId,
    related_article_data,
    language: selectedLanguage,
    recentlyAddedArticles,
    footNoteCategoryUrls,
    formDataProps,
    categoryData,
    assesmentArticle,
  } = articlePagePropsData;
  const content = articleDetail?.data?.post?.content;
  const productContent = articleDetail?.data?.post?.generic_repost;
  const productInfo = articleDetail?.data?.post?.product;
  const articlePost = articleDetail?.data?.post;
  const contentData = content?.tags;
  const postContent = content;
  const contentStage = articlePost?.content_stage;
  let relatedWebUrl = getCustomRelatedUrls(content);
  const bottomPageRef = useRef(null);
  const [addedToCart, setAddedToCart] = useState(false);
  const [showCartSnackBar, setShowCartSnackBar] = useState(false);
  const [showAdsBanner, setShowAdsBanner] = useState(false);
  const [isIndianUser, setIsIndianUser] = useState(false);
  const [userType, setUserType] = useState();
  const [contentWithAds, setContentWithAds] = useState(null);
  const webUrlSplit = articleId?.split('-');
  const integerId = webUrlSplit?.pop();
  const installLink = `https://app.mylofamily.com/article/${integerId}`;
  const [hideButton, setHideButton] = useState(false);
  const snackBarTimeoutRef = useRef(null);
  const deviceType = useRef();
  const cartItems = getCartItems();
  const amazonAffiliateData = getUsDataById(articleId);
  const metaDescription = content?.meta_description;
  const metaTitle = content?.meta_title;
  const url =
    articleIdCanonicalMapping[articleId] ||
    encodeURIComponent(content?.web_url)?.split('%2F').join('/');
  const bottomPageInteraction = useIntersection(bottomPageRef, {
    root: null,
    rootMargin: '0px',
    threshold: 0.2,
  });
  const canonicalUrl = `${getPublicUrl()}${url}`;
  const openGraphData = {
    title: metaTitle,
    description: metaDescription,
    type: 'website',
    url: canonicalUrl,
    images: [
      {
        url: content?.webpImages?.[0],
        width: 800,
        height: 800,
      },
    ],
  };
  let hrefData = [];
  hrefData.push({
    hrefLang: selectedLanguage,
    href: canonicalUrl,
  });
  hrefData = [...hrefData, ...relatedWebUrl];
  if (!content?.webpImages?.[0]) {
    delete openGraphData['images'];
  }
  const cartCtaHandler = () => {
    fireEvent({
      category: 'clicked_go_to_cart_in_snackbar',
      screen_name: getScreenName(),
      item_count: cartItems.length || 0,
      id: cartItems.pop(),
    });
    goToCartHandler();
  };
  const getDataByStage = () => {
    switch (contentStage) {
      case 'mother':
        return motherNudge;
      case 'pregnant':
        return pregnancyNudge;
      case 'ttc':
        return ttcNudge;
      default:
        return motherNudge;
    }
  };
  const [contentByStage, setContentByStage] = useState(getDataByStage());

  useEffect(() => {
    if (articlePagePropsData?.articleDetail) {
      setContentByStage(getDataByStage());
      const topicName = postContent?.tagsWithId[0]?.description;
      const topicNameWithoutSpace = topicName
        ?.split(' ')
        ?.join('')
        ?.toLowerCase();
      const additionalCategoryEventData =
        updatedCategoryMapping[topicNameWithoutSpace] || {};
      fireViewedScreenEvent(
        articleId,
        postContent?.title,
        topicName,
        additionalCategoryEventData,
      );
      deviceType.current = getDeviceType();
    }
  }, [articlePagePropsData]);
  useEffect(() => {
    if (related_article_data?.length > 0) {
      let cardId = [];
      related_article_data.forEach((element) => {
        cardId.push(element?.object_id);
      });

      fireServedSectionEvent('Read more on mylo', cardId, 'article');
    }
    setUserType(getWebUserType());
    setIsIndianUser(isUserFromIndia());
    setShowAdsBanner(
      assesmentArticle ? (isUserFromIndia() ? false : true) : true,
    );
    let tag = document.createElement('script');
    tag.src =
      'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5148846221422351';
    if (assesmentArticle ? (isUserFromIndia() ? false : true) : true) {
      document.body.appendChild(tag);
    } else {
      document.body.contains(tag) ? document?.body?.removeChild(tag) : null;
    }
  }, [articleId]);

  useEffect(() => {
    setAddedToCart(false);
    if (addedToCart && !showNewCartFlow()) {
      clearTimeout(snackBarTimeoutRef.current);
      setShowCartSnackBar(true);
      snackBarTimeoutRef.current = setTimeout(() => {
        setShowCartSnackBar(false);
      }, 3000);
    }
  }, [addedToCart]);
  useEffect(() => {
    if (bottomPageInteraction?.isIntersecting) {
      setHideButton(true);
    } else {
      setHideButton(false);
    }
  }, [bottomPageInteraction]);

  const checkAndUpdateArticlesData = async () => {
    const context = {
      params: { articleId: props.articleId },
      locale: props.locale,
    };
    if (!props.articleDetail) {
      const data = await getArticleData(context, 'client');
      setArticlePagePropsData(data.props);
    }
  };

  useEffect(() => {
    checkAndUpdateArticlesData();
  }, [props.articleId]);
  useEffect(() => {
    if (props.articleDetail) {
      setArticlePagePropsData(props);
    }
  }, [props]);

  if (!articlePagePropsData.articleDetail) {
    return <Loader></Loader>;
  }
  const query_add = {
    internal_source: 'organic_article',
    internal_medium: articleId,
  };
  // const userTypeCheck = () => {
  //     return userType === "A";
  // };
  const showNewHeader =
    articleId == '191442' || articleId == '188419' || articleId == '184231';
  const tagsForBaby =
    content.tags?.[0]?.toLowerCase() === 'babycare' ||
    content.tags?.[0]?.toLowerCase() === 'babynames' ||
    showNewHeader;
  useEffect(() => {
    window.googletag = window.googletag || { cmd: [] };

    let interstitialSlot;
    if (googletag.cmd)
      googletag.cmd.push(() => {
        // Define a web interstitial ad slot.
        interstitialSlot = googletag.defineOutOfPageSlot(
          '/23129527962/webInterstitialAd',
          googletag.enums.OutOfPageFormat.INTERSTITIAL,
        );

        // Slot returns null if the page or device does not support interstitials.
        if (interstitialSlot) {
          // Enable optional interstitial triggers and register the slot.
          interstitialSlot.addService(googletag.pubads()).setConfig({
            interstitial: {
              triggers: {
                navBar: true,
                unhideWindow: true,
              },
            },
          });
          googletag.pubads().addEventListener('slotOnload', (event) => {
            if (interstitialSlot === event.slot) {
              console.log('interstitial ad loaded');
            }
          });

          // Enable SRA and services.
          googletag.pubads().enableSingleRequest();
          googletag.enableServices();
          googletag.display(interstitialSlot);
        }
      });
  }, [articleId]);
  return (
    <>
      {content && (
        <ArticleHead
          content={content}
          articleImage={postContent?.webpImages?.[0]}
          language={selectedLanguage}
          articleId={articleId}
        />
      )}
      {true ? (
        <>
          <NextSeo
            title={metaTitle}
            description={metaDescription}
            openGraph={openGraphData}
            canonical={canonicalUrl}
            languageAlternates={hrefData}
          />
        </>
      ) : null}
      <GlobalStyle />
      {assesmentArticle && !showNewHeader && isIndianUser ? (
        <AssessmentStrip articleId={articleId} />
      ) : null}
      <NewHeader
        setAddedToCart={setAddedToCart}
        addedToCart={addedToCart}
        categoryData={categoryData}
        showShopCta={!assesmentArticle || showNewHeader}
        showNewHeader={!assesmentArticle || showNewHeader}
        stage={articlePost?.content_stage}
        babyCareProduct={tagsForBaby}
        userType={userType}
        hideTopStrip={true}
        store={true}
      />

      <HomeWrapper
        showNewHeader={!assesmentArticle || showNewHeader}
        userType={userType}
      >
        {articleDetail?.data ? (
          <>
            <SnackBar className={showCartSnackBar ? 'show' : ''}>
              ADDED TO CART SUCCESSFULLY{' '}
              <span onClick={cartCtaHandler}>GO TO CART</span>
            </SnackBar>
            {showAdsBanner ? (
              <ScrollWrapper
                data={{
                  category: 'impression_ad_in_general_screen',
                  screen_name: getScreenName(),
                  parent: 'display ad',
                  support_variable: 'first fold',
                }}
              >
                {/* <DesktopHidden>
                                    <AdPublisherTag
                                        adPath="/23129527962/articleTopBanner"
                                        adSizes={[320, 50]}
                                        adSlot="div-gpt-ad-1714555837977-0"
                                        minHeight="50px"
                                        firstFold={true}
                                    />
                                </DesktopHidden>
                                <MobileHidden showAPlusPlusExp={true}>
                                    <AdPublisherTag
                                        adPath="/23129527962/articleTopDesktop"
                                        adSizes={[728, 90]}
                                        adSlot="div-gpt-ad-1714632558623-0"
                                        minHeight="90px"
                                        firstFold={true}
                                    />
                                </MobileHidden> */}
                <AdsBanner
                  data-ad-slot="6130196369"
                  data-full-width-responsive="true"
                  data-ad-format="auto"
                  firstLoad={true}
                  showStrip={true}
                />
              </ScrollWrapper>
            ) : null}

            <Breadcrumbs breadCrumbs={postContent?.breadcrumbs} />
            <ArticleGridSection>
              <InthisArticleSection
                data={postContent}
                articleData={formDataProps}
                formId={27}
              />
              <section id="articleDetail">
                {articlePost?.contentType != 'Infographic' && (
                  <ArticleImage
                    data={postContent?.webpImages}
                    topBannerTitle={postContent?.title}
                    articleData={content}
                  />
                )}

                {/* In Article Ad */}
                <ArticleDetail
                  selctedLanguage={selectedLanguage}
                  data={postContent}
                />

                {articlePost?.contentType === 'Infographic' && (
                  <InfographicImage
                    data={postContent?.webpImages}
                    altDescription={metaDescription}
                  />
                )}

                <ExpertSection
                  data={postContent}
                  heading={'Medically Reviewed by'}
                />
                {showAdsBanner ? (
                  <ScrollWrapper
                    data={{
                      category: 'impression_ad_in_general_screen',
                      screen_name: getScreenName(),
                      parent: 'display ad',
                      support_variable: 'before content',
                    }}
                  >
                    <AdsBanner
                      data-ad-format="fluid"
                      data-ad-slot={'3465526070'}
                      data-ad-layout="in-article"
                    />

                    {/* <AdPublisherTag
                                            adPath="/23129527962/webArticleTop"
                                            adSizes={[300, 250]}
                                            adSlot="div-gpt-ad-1714480087612-0"
                                            minHeight="250px"
                                        /> */}
                  </ScrollWrapper>
                ) : null}

                <Content
                  data={postContent}
                  query_add={query_add}
                  // isUsUser={isUsUser}
                  showAdBanner={showAdsBanner}
                  amazonAffiliateData={amazonAffiliateData}
                  modifiedHtmlString={props.modifiedHtmlString}
                />
                {productContent ? (
                  <ProductShowcase
                    data={productContent}
                    productInfo={productInfo}
                    userType={userType}
                    articleId={articleId}
                  />
                ) : null}

                {/* {isUsUser ? (
                                    <AmazonProductCarousel
                                        amazonAffiliateData={
                                            amazonAffiliateData
                                        }
                                    />
                                ) : null} */}

                <IsthisHelpfulSection
                  installLink={installLink}
                  contentId={articleId}
                  contentType={'article'}
                  contentData={contentData}
                />
                <ExpertSection
                  data={postContent}
                  showCreatedBy={true}
                  heading={'Medically Reviewed by'}
                />
                <DownloadAppBanner
                  contentByStage={contentByStage}
                  contentStage={contentStage}
                  installLink={installLink}
                  articleId={articleId}
                />
              </section>
              <section>
                <RelatedArticlesNew
                  pageType={'article'}
                  similarElements={articleDetail?.data?.similarElements}
                />
                {/* In Article Ad */}
                {showAdsBanner ? (
                  <ScrollWrapper
                    data={{
                      category: 'impression_ad_in_general_screen',
                      screen_name: getScreenName(),
                      parent: 'display ad',
                      support_variable: 'bottom section',
                    }}
                  >
                    {/* <MobileHidden showAPlusPlusExp={true}>
                                            <AdPublisherTag
                                                adPath="/23129527962/articleBottom1"
                                                adSizes={[300, 600]}
                                                adSlot="div-gpt-ad-1714632787157-0"
                                                minHeight="250px"
                                            />
                                        </MobileHidden>
                                        <DesktopHidden>
                                            <AdPublisherTag
                                                adPath="/23129527962/articleBottom1"
                                                adSizes={[300, 250]}
                                                adSlot="div-gpt-ad-1714561766805-0"
                                                minHeight="250px"
                                            />
                                        </DesktopHidden> */}

                    <AdsBanner
                      data-ad-slot="1504555646"
                      data-ad-format="auto"
                      data-full-width-responsive="true"
                    />
                  </ScrollWrapper>
                ) : null}

                <RelatedQuestionNew
                  similarElements={articleDetail?.data?.similarElements}
                  pageType={'article'}
                  questionId={articleId}
                />
                <RelatedArticleTopics
                  pageType={'article'}
                  topics={postContent?.tagsWithId}
                />
              </section>
            </ArticleGridSection>
            <AdsBanner
              data-ad-slot="8240811812"
              data-ad-format="auto"
              data-full-width-responsive="true"
            />
            {/* {showAdsBanner ? (
                            <AdPublisherTag
                                adPath="/23129527962/articleBottom2"
                                adSizes={[300, 250]}
                                adSlot="div-gpt-ad-1714561948788-0"
                                minHeight="250px"
                            />
                        ) : null} */}

            <ProductsMayLikeSection>
              {/* {!isUsUser ? ( */}
              <ArticleProductCard
                setAddedToCart={setAddedToCart}
                similarElements={articleDetail?.data?.similarElements}
                rupeeSymbol={true}
                query_add={query_add}
              />
              {/* ) : null} */}
            </ProductsMayLikeSection>
            {related_article_data.length > 0 && (
              <div>
                <BannerTitle>
                  <h2>Read more on mylo</h2>
                </BannerTitle>
                <SimilarVideoSection readMoreMylo>
                  {related_article_data?.map((data, index) => {
                    return (
                      <Card
                        primaryTagId={data?.primary_tag_id}
                        index={index}
                        cardData={data?.content}
                        contentType={data?.content_type}
                        heading={'Read more on mylo'}
                        key={index}
                        readMoreMylo={true}
                        articleId={articleId}
                      />
                    );
                  })}
                </SimilarVideoSection>
              </div>
            )}
            {recentlyAddedArticles.length ? (
              <RecentlyAddedArticlesCover
                recentArticles={recentlyAddedArticles}
                location={'article'}
              />
            ) : null}
          </>
        ) : (
          <FixedWithHeightDiv></FixedWithHeightDiv>
        )}
      </HomeWrapper>

      <NewFooter
        bottomRef={bottomPageRef}
        content={footNoteCategoryUrls}
        heading={metaTitle}
      />

      {/* {!userTypeCheck() && !assesmentArticle ? (
                <AppInstallCover
                    installLink={installLink}
                    contentByStage={contentByStage}
                    hideButton={hideButton}
                />
            ) : null} */}
    </>
  );
}
